import { Select } from '@scuf/common';
import i18next from 'i18next';
import { useEffect, useMemo } from 'react';
import {
  IOrganisation
} from '../onboarding/onboardingModels';
import { useSelector, useDispatch } from 'react-redux';
import { IOption } from '@scuf/common/dist/components/Select/ISelectProps';
import {
  IOrganisationState,
  setSelectedOrganisation,
  setSelectedGatewayOrganisation
} from './Redux/Global/globalShared';
import './OrganisationList-theme.scss';

interface IOrganisationListProps {
  OFFERING: string;
  BASE_URL: string;
}

const OrganisationList = (props: IOrganisationListProps) => {
  const organisationList = useSelector(
    (state: IOrganisationState) => state.globalShared.organisationList
  );
  const isLoadingOrganisationList = useSelector(
    (state: IOrganisationState) => state.globalShared.organisationListLoading
  );
  const selectedOrganisation = useSelector(
    (state: IOrganisationState) => state.globalShared.selectedOrganisation
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      organisationList &&
      organisationList &&
      organisationList.length > 0
    ) {
      // Set org to the first and only entry if only 1
      if (selectedOrganisation === null) {
        dispatch(
          setSelectedOrganisation(
            organisationList.find(item => item.zuoraAccountNo !== null)
          )
        );
      }
    }
  }, [organisationList]);


  const orgDataToSelectOptions = useMemo(
    () => () => {
      return organisationList && organisationList.length
        ? organisationList
          .filter(item => item.zuoraAccountNo)
          .map((org: IOrganisation) => {
            const option: IOption = { value: org.id, text: org.name };
            return option;
          })
        : [];
    },
    [organisationList]
  );

  const setSelectedOrganisationList = (orgID: string) => {
    dispatch(setSelectedOrganisation(selectOrgFromDropdown(orgID)));
    dispatch(setSelectedGatewayOrganisation(selectOrgFromDropdown(orgID)));
  };

  const selectOrgFromDropdown = (orgId: string) => {
    return organisationList && organisationList
      ? organisationList.find((org: IOrganisation) => orgId === org.id)
      : undefined;
  };

  return (
    <Select
      className="org-list-selector"
      options={orgDataToSelectOptions()}
      value={selectedOrganisation ? selectedOrganisation.id : ''}
      placeholder={
        !isLoadingOrganisationList ? i18next.t('selectOrg') : undefined
      }
      onChange={orgId => {
        setSelectedOrganisationList(orgId);
      }}
      loading={isLoadingOrganisationList}
    />
  );
};

export default OrganisationList;
